<!-- PDF container -->
<div [hidden]="!hasPdfReport" class="panel-height" [id]="containerId"></div>

<!-- Upload (only matters when PDF viewer is active and no PDF exists) -->
<div *ngIf="isPrimary && !hasPdfReport">
	<app-upload-workflow-file
		(uploadAction)="emitUploadWorkflowFile()"
		[uploadedFiles]="uploadedFiles"
	></app-upload-workflow-file>
</div>
